import React, { useRef } from 'react';
import { useFormContext } from '../../components/FormContext';


const VisaSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFieldValue,
    setFormErrors, 
    setFile,
    setModifiedFields
  } = useFormContext();

const visaInputRef = useRef(null);
const handleSelectChange = (field, e) => {
    const value = e.target.value;
    
    setFieldValue('visaType', value);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    
    if (value.trim() === '' ) {
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } 
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
    
  };

  const validateFutureDate = (field, e) => {
  const value = e.target.value;
    setFieldValue('visaExpiry', value);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
  
  
  
  if (!value) {
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else {
        
      const selectedDate = new Date(value);
      const today = new Date();
        
      if (selectedDate < today) {
          error = `${field.charAt(0).toUpperCase() + field.slice(1)} cannot be in the past`; 
        }
        
      
    }
  
  if (error) {
          setFormErrors(prev => ({...prev, [field]: error}));
        } else {
          setFormErrors(prev => {
            const newErrors = {...prev};
            delete newErrors[field];
            return newErrors;
          });
        }
};


const validatePDFFile = (field, e) => {
  const file = e.target.files ? e.target.files[0] : null;
  setFile('visaDocument', file);
  setModifiedFields(prev => new Set([...prev, field]));
  
  let error = null;
  if (!file) {
    error = `PDF file is required for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
  } else if (file.type !== 'application/pdf') {
    error = `PDF file is only accepted for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
  }
  
  if (error) {
    setFormErrors(prev => ({...prev, [field]: error}));
  } else {
    setFormErrors(prev => {
      const newErrors = {...prev};
      delete newErrors[field];
      return newErrors;
    });
  }
};

  return (
    <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Visa Information</h4>

              <div className="space-y-4">
                <div>
                  <label htmlFor="visa-type" className="block text-sm font-medium text-gray-700 mb-1">
                    Visa Type
                  </label>
                  <select
                    id="visa-type"
                    name="visaType"
                    value={formData.visaType}
                    onChange={(e) => handleSelectChange('visaType', e)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">Select</option>
                    <option value="Citizen">Citizen</option>
                    <option value="Permanent Residency">Permanent Residency</option>
                    <option value="Student Visa">Student Visa</option>
                    <option value="Bridging Visa">Bridging Visa</option>
                    <option value="Family & Partner Visa">Family & Partner Visa</option>
                    <option value="Visitor Visa">Visitor Visa</option>
                    <option value="Trade Visa">Trade Visa</option>
                    <option value="Refugee Visa">Refugee Visa</option>
                    <option value="Other">Other</option>
                    <option value="Temporary Graduate">Temporary Graduate</option>
                    <option value="Temporary Activity">Temporary Activity</option>
                  </select>
                  
                  {formErrors.visaType && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('visaType') && (
                    <div className="text-sm text-red-600 mt-1">
                      {formErrors.visaType}
                    </div>
                  )}
                </div>
                
                <div>
                  <label htmlFor="visa-expiry" className="block text-sm font-medium text-gray-700 mb-1">
                    Visa Expiry Date
                  </label>
                  <input
                    type="date"
                    id="visa-expiry"
                    name="visaExpiry"
                    value={formData.visaExpiry}
                    onChange={(e) => validateFutureDate('visaExpiry', e)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  />
                  
                  {formErrors.visaExpiry && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('visaExpiry') && (
                    <div className="text-sm text-red-600 mt-1">
                      {formErrors.visaExpiry}
                    </div>
                  )}
                </div>
                <div>
                  <input
                    id="visa-document-upload"
                    type="file"
                    name="visaDocument"
                    accept=".pdf"
                    className="hidden"
                    onChange={(e) => validatePDFFile('visaDocument',e)}
                    ref={visaInputRef}
                  />
                  
                  {!formData.visaDocument ? (
                    <button
                      type="button"
                      onClick={() => visaInputRef.current.click()}
                      className="upload-button flex items-center justify-center px-4 py-2 w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg shadow hover:from-blue-600 hover:to-indigo-700 transition-all duration-200"
                    >
                      <span className="font-medium">Upload Visa Document</span>
                    </button>
                  ) : (
                    <div className="file-info p-3 bg-gray-50 rounded-md border border-gray-200">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <span className="file-name text-sm font-medium text-gray-700">
                            {formData.visaDocument.name}
                          </span>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setFile('visaDocument', null);
                            // Use the existing validation function with a mock empty event
                            validatePDFFile('visaDocument', { target: { files: null } });
                          }}
                          className="text-sm text-red-600 hover:text-red-800 font-medium"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  )}
                       
                  {formErrors.visaDocument && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('visaDocument') && (
                    <div className="text-sm text-red-600 mt-1">
                      {formErrors.visaDocument}
                    </div>
                  )}
                </div>
              </div>
            </div>

      
    );
};

export default VisaSection;